import type {PodRequestFn} from '../usePodRequest';

const OUTLOOK_ADD_IN_DEAL_AUTOCOMPLETE_PATH =
  '/outlook_add_in/deal_autocomplete';

export type OutlookDealJson = {
  id: number;
  name: string;
};

export type OutlookDealAutocompleteJson = {
  deals: OutlookDealJson[];
};

export const buildOutlookDealAutocompletePath = (
  agencyId: number,
  options: {
    query?: string;
  } = {}
): string => {
  const params = new URLSearchParams();
  params.set('agency_id', String(agencyId));
  const query = options.query?.trim();
  if (query) {
    params.set('query', query);
  }
  return `${OUTLOOK_ADD_IN_DEAL_AUTOCOMPLETE_PATH}?${params.toString()}`;
};

export const fetchOutlookDealAutocomplete = async (
  request: PodRequestFn,
  agencyId: number,
  options: {
    query?: string;
  } = {}
): Promise<OutlookDealAutocompleteJson> => {
  const path = buildOutlookDealAutocompletePath(agencyId, options);
  const response = await request(path);
  const text = await response.text();
  if (!response.ok) {
    throw new Error(text || `Request failed (${response.status})`);
  }
  return JSON.parse(text) as OutlookDealAutocompleteJson;
};
